import type { ReactNode } from 'react';
import { cn } from 'v5/platform/dom/cn';

export interface NameWithPronounsProps {
  /** Primary name (string or node). */
  name: ReactNode;
  /** As the settings write them; nothing beside the name when blank or `null`. */
  pronouns: string | null;
  className?: string;
  /** Additional classes for the name segment (e.g. font weight). */
  nameClassName?: string;
}

/**
 * A resource's name with its pronouns beside it; keeps pronouns visible (no clip) when space is
 * tight. For a host that has the pronouns already; `ResourceNameWithPronouns` reads them from the
 * settings.
 */
export function NameWithPronouns({
  name,
  pronouns,
  className,
  nameClassName
}: NameWithPronounsProps) {
  const trimmed = pronouns?.trim();
  if (!trimmed) {
    return <span className={className}>{name}</span>;
  }

  return (
    <span
      className={cn(
        'inline-flex min-w-0 max-w-full flex-wrap items-baseline gap-y-0.5',
        className
      )}
    >
      <span className={cn('font-inherit', nameClassName)}>{name}</span>
      <span className="ml-1 shrink-0 text-sm text-fg-muted">{trimmed}</span>
    </span>
  );
}
